export default {
  /**
   * 数字型のバリデート
   * @params {Number} s.min  許容最小値
   * @params {Number} s.max  許容最大値
   */
  validateNumber (value, s) {
    if (typeof value !== 'number') return false
    if (s && s.min !== undefined && value < s.min) return false
    if (s && s.max !== undefined && value > s.max) return false
    return true
  },


  /**
   * ID（int型）データのチェック
   */
  validId (value) {
    return typeof value === 'number' && value !== null
  },
  /**
   * IdentityId（String型）データのチェック
   */
  validIdentityId (value) {
    if (!value) return false
    return typeof value === 'string' && value !== ''
  },
  /**
   * 文字列型データのチェック
   */
  validText (value) {
    return value !== '' && value !== null
  },
  /**
   * 配列型データのチェック
   */
  validArray (value) {
    if (!value) return false
    return typeof value === 'object' && value.length > 0
  },
  /**
   * 日付型データのチェック
   */
  validDate (value) {
    if (!value) return false
    return typeof value === 'object' && value !== null
  },
  /**
   * ファイル型データのチェック
   */
  validFile (value) {
    if (!value) return false
    return typeof value === 'object' && value !== null
  },
  /**
   * nullではないかのチェック
   */
  validNotNull (value) {
    return value !== null
  },
  /**
   * セレクトボックスのチェック
   */
  validSelect (value) {
    return value !== '' && value !== null
  },
  /**
   * ラジオボタンのチェック
   */
  validRadio (value) {
    return value !== '' &&
      value !== null &&
      value !== undefined
  },

  /**
   * 文字数制限
   */
  charLimit (str, limit) {
    return str.length > limit
      ? str.slice(0, -1)
      : str;
  },
  /**
   * 文字数制限（limitには1バイトを1、2バイトを2として入れる）
   */
  charByteLimit (str, limit) {
    let array = str.split('')
    let bytes = 0
    let res = ''
    array.forEach(item => {
      bytes += (item.match(/[ -~]/)) ? 1 : 2
      if (bytes <= limit) {
        res += item
      }
    })
    return res
  },
}
